import { render, staticRenderFns } from "./MySuppliers.vue?vue&type=template&id=6ccf6634&scoped=true"
import script from "./MySuppliers.vue?vue&type=script&lang=js"
export * from "./MySuppliers.vue?vue&type=script&lang=js"
import style0 from "./MySuppliers.vue?vue&type=style&index=0&id=6ccf6634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf6634",
  null
  
)

export default component.exports